// Copyright © 2024 Broadcom Inc. and its subsidiaries. All Rights Reserved.
import { get } from 'lodash';

const styles = ({ theme, padding, breakpoint, color, fontSize, typography }) => {
  return ({
    registrationSettingsContainer: {
      margin: 36,
      marginTop: 0,
      paddingLeft: get(padding, 'p36'),
      paddingRight: get(padding, 'p36'),
      paddingBottom: get(padding, 'p36'),
      paddingTop: get(padding, 'p36'),
      backgroundColor: color.uiBackground,
      minHeight : '100vh',
    },
    pageTitle: {
      color: get(color, 'pageTitle'),
      fontFamily: get(typography, 'pageTitle'),
      fontSize: get(fontSize, 'pageTitle'),
      marginTop: 6,
    },
    smallTitle: {
      color: get(color, 'smallTitle'),
      fontFamily: get(typography, 'smallTitle'),
      fontSize: get(fontSize, 'smallTitle'),
      marginTop: 0,
      marginBottom: 0,
      verticalAlign: 'middle',
      lineHeight: '34px',
    },
    smallLabel: {
      color: get(color, 'smallLabel'),
      fontFamily: get(typography, 'smallLabel'),
      fontSize: get(fontSize, 'smallLabel'),
    },
    hr: {
      color: get(color, 'border'),
      borderTopWidth: 1,
      borderRightWidth: 0,
      borderBottomWidth: 0,
      borderLeftWidth: 0,
    },
    workflowHead: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: 40,
      marginBottom: 0,
      verticalAlign: 'middle',
    },
    bodyText: {
      color: get(color, 'bodyText'),
      fontFamily: get(typography, 'bodyText'),
      fontSize: get(fontSize, 'bodyText'),
    },
    details: {
      marginBottom: 50,
      width : "100%",
    },
    listItem: {
      marginTop: 10,
      padding: 2,
      paddingLeft: 16,
      paddingRight: 16,
      '& .MuiCheckbox-root': {
        padding: '4px',
      },
    },
    listItemText: {
      color: get(color, 'black'),
      marginTop : 2,
      marginBottom : 2,
      textOverflow: 'ellipsis',
      '& .MuiTypography-root': {
        lineHeight: '1.5',
      },
    },
    listItemTitle: {
      fontFamily: 'open-sans-bold',
    },
    listItemTextPrimary: {
      color: get(color, 'siteTitle'),
      fontFamily: get(typography, 'pageTitle'),
      fontSize: get(fontSize, 'siteTitle'),
      marginTop: 0,
      marginBottom: 0,
    },
    listItemTextSecondary: {
      color: "black",
      fontSize: get(fontSize, 'bodyText'),
    },
    listItemIcon: {
      alignSelf : 'flex-start',
      minWidth: 0,
      '& .MuiSvgIcon-root': {
        paddingRight: '2px',
        width: '20px',
        height: '20px',
      },
    },
    removeAdminUsers: {
      marginBottom: 40,
    },
    textFieldContainer: {
      width: "100%",
    },
    notificationContainerRegistrationSettings: {
      minWidth: '200px !important',
      width: 'auto !important',
      left: '45% !important',
      backgroundColor: get(color, 'white'),
      color: get(color, 'black'),
      fontWeight: 800,
    },
    notificationWidthClass: {
      width: 'calc(100% - 100px)',
      padding: '0 15px',
      marginLeft: get(theme, 'margin.m0'),
    },
    settingsSection: {
      paddingBottom: 120,
    },
    switchHelperText: {
      color: get(color, 'bodyText'),
      fontFamily: get(typography, 'bodyText'),
      fontSize: get(fontSize, 'bodyText'),
    },
    switchHR: {
      color: get(color, 'border'),
      borderTopWidth: 1,
      borderRightWidth: 0,
      borderBottomWidth: 0,
      borderLeftWidth: 0,
    },
    switchTitle: {
      color: get(color, 'smallTitle'),
      fontFamily: get(typography, 'smallTitle'),
      fontSize: get(fontSize, 'smallTitle'),
      marginTop: 0,
      marginBottom: 0,
      verticalAlign: 'middle',
      lineHeight: '34px',
    },
    switchTitleSection: {
      alignItems: 'center',
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: 40,
      marginBottom: 0,
      verticalAlign: 'middle',
    },
    thresholdsHelperText: {
      color: get(color, 'bodyText'),
      fontFamily: get(typography, 'bodyText'),
      fontSize: get(fontSize, 'bodyText'),
    },
    thresholdCategoryField: {
      display: 'inline-block',
      marginBottom: '0 !important',
      marginLeft: 8,
      marginRight: 8,
      marginTop: '0 !important',
      width: 90,
    },
    activeThresholdListItemText: {
      alignItems: 'baseline',
      display: 'inline-flex',
      flexWrap: 'wrap',
    },
    thresholdListItemText: {
      alignItems: 'center',
      display: 'inline-flex',
      flexWrap: 'wrap',
    },
    thresholdStartItemIcon: {
      color: '#3E7C07 !important',
      minWidth: 32,
    },
    thresholdPrepareItemIcon: {
      color: '#F7CD3B !important',
      minWidth: 32,
    },
    thresholdWarnItemIcon: {
      color: '#E47226 !important',
      minWidth: 32,
    },
    thresholdErrorItemIcon: {
      color: '#B30303 !important',
      minWidth: 32,
    },
    thresholdTextField: {
      paddingBottom: '0 !important',
      paddingTop: '0 !important',
    },
    thresholdListItem: {
      color: get(color, 'bodyText'),
      fontFamily: get(typography, 'bodyText'),
      fontSize: get(fontSize, 'bodyText'),
      lineHeight: '40px',
      marginBottom: 8,
      marginTop: 8,
    },
    [`@media (min-width: ${get(breakpoint, 'md')})`]: {
      details: {
        width: '60%',
      },
    },
    [`@media (max-width: ${get(breakpoint, 'md')})`]: {
      registrationSettingsContainer: {
        margin: 0,
      },
    },
    [`@media (max-width: ${get(breakpoint, 'sm')})`]: {
      registrationSettingsContainer: {
        paddingLeft: get(padding, 'p16'),
        paddingRight: get(padding, 'p16'),
      },
    },
  });
}

export default styles;
